import React, { useState } from 'react';

/** Proxied crest URL — works in builder (Vite proxy) and on embed host. */
export function logoUrlForTeamName(name) {
  const q = String(name || '').trim();
  if (!q) return null;
  return `/api/v1/images/team?name=${encodeURIComponent(q)}`;
}

function teamNameFromRow(row, side) {
  if (!row) return '';
  if (side === 'home') return row.home || '';
  if (side === 'away') return row.away || '';
  return row.team || row.name || '';
}

/** Prefer proxied logo path from widget API; fall back to direct CDN URL, then name lookup. */
export function pickTeamLogo(row, side) {
  if (!row) return null;
  if (side === 'home') {
    return row.homeLogoProxy || row.homeLogo || logoUrlForTeamName(row.home);
  }
  if (side === 'away') {
    return row.awayLogoProxy || row.awayLogo || logoUrlForTeamName(row.away);
  }
  return (
    row.teamLogoProxy ||
    row.teamLogo ||
    logoUrlForTeamName(row.team || row.name)
  );
}

/** Team crest when API provides logo; initials fallback only if image fails. */
export default function TeamBadge({ name = '', logoUrl = null, size = 28 }) {
  const [failed, setFailed] = useState(false);
  const resolvedUrl = logoUrl || logoUrlForTeamName(name);
  const showImg = resolvedUrl && !failed;

  const initials = String(name)
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 3)
    .toUpperCase();

  if (showImg) {
    return (
      <img
        src={resolvedUrl}
        alt=""
        width={size}
        height={size}
        className="inline-block shrink-0 rounded-full object-contain"
        style={{ width: size, height: size, background: 'var(--sw-surface)' }}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span
      className="inline-flex items-center justify-center rounded-full font-bold shrink-0"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.32,
        background: 'var(--sw-border)',
        color: 'var(--sw-muted)',
      }}
      aria-hidden
    >
      {initials || '?'}
    </span>
  );
}
